import React from "react";
import {
    UiCol,
    UiRowContainer,
    UiSingleContainer,
    UiSingleRow,
} from "../../../components/grid-container/GridContainer";
import {
    UiButtonPrimary,
    UiButtonIcon,
} from "../../../components/form/UiButton";
import AddToFavourites from "../../../../../styles/img/svg/AddToFavourites";
import { UiInput } from "../../../components/form/UiInput";
import UiAmountTile from "../../../components/common/UiAmountTile";

import {
    UiProductContent,
    UiProductContentMainTitle,
    UiProductContentSubTitle,
    UiProductContentSection,
    UiProductContentDescription,
} from "../../../components/common/UiProductElements";
import { useNavigate } from "react-router-dom";

export default function ProductContent(props) {
    let navigate = useNavigate(); 
    const buyNow = () => {
        let path = `../../ui/order-confirmation`; 
        navigate(path);
        
    }
    return (
        <>
            <UiProductContent>
                <UiProductContentMainTitle title="Ultimate London Weekend" />
                <UiProductContentSubTitle subtitle="Lorem Epsum Product - 2,500 points" />
                <UiProductContentDescription description="Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna." />
                <UiSingleRow className="mt-3">
                    <UiSingleRow className="align-items-center mb-3">
                        <UiCol lg="5" className="d-flex align-items-center ">
                            <UiAmountTile data={["£50", "£150", "£100"]} />
                            <span className="sb-or-text">OR</span>
                        </UiCol>

                        <UiCol lg="4" xl="4" className="sb-other-input">
                            <UiInput placeholder="Enter Other Amount" />
                        </UiCol>
                    </UiSingleRow>

                    <UiCol lg="4" xl="4" sm="6">
                        <UiButtonPrimary
                            btnName="Buy Now (2,500 Points + £50)"
                            className="w-100"
                            onClick={buyNow}
                        />
                    </UiCol>
                    <UiCol lg="4" xl="4" sm="6">
                        <UiButtonIcon
                            btnName="Add to favourites"
                            icon={<AddToFavourites />}
                        />
                    </UiCol>
                </UiSingleRow>

                <UiProductContentSection>
                    <p>
                        Timperdiet gravida scelerisque odio nunc. Eget felis,
                        odio bibendum quis eget sit lorem donec diam. Volutpat
                        sed orci turpis sit dolor est a pretium eget. Vitae
                        turpis orci vel tellus cursus lorem vestibulum quis eu.
                        Ut commodo, eget lorem venenatis urna.
                    </p>
                    <p>
                        Timperdiet gravida scelerisque odio nunc. Eget felis,
                        odio bibendum quis eget sit lorem donec diam. Volutpat
                        sed orci turpis sit dolor est a pretium eget. Vitae
                        turpis orci vel tellus cursus lorem vestibulum.
                    </p>
                    <UiSingleRow className="mt-4">
                        <UiCol lg="4" xl="4" sm="6">
                            <UiButtonPrimary
                                btnName="Instant Access Voucher"
                                disabled="true"
                                className="w-100"
                            />
                        </UiCol>
                        <UiCol lg="4" xl="4" sm="6">
                            <UiButtonPrimary
                                btnName="Instant Access Voucher"
                                disabled="true"
                                className="w-100"
                            />
                        </UiCol>
                    </UiSingleRow>
                </UiProductContentSection>

                {/* <UiProductContentOverview description="Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna. Pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu.">
                    <UiProductContentFeatures
                        wifi={true}
                        bathup={true}
                        breakfast={true}
                        kingbed={true}
                        size={true} />
                </UiProductContentOverview> */}
            </UiProductContent>
        </>
    );
}
